<template>
  <dd-dialog-modal
    :title="title"
    :description="description"
    :visible="visible"
    @cancel="$emit('cancel')"
    v-bind="$attrs"
  >
    <template v-slot:buttons>
      <dd-button type="primary" outline @click="$emit('cancel')">Nee</dd-button>
      <dd-button type="primary" @click="navigateToCustomer">Ja</dd-button>
    </template>
  </dd-dialog-modal>
</template>

<script>

export default {
  name: "NavigateToCustomerModal.vue",
  props:{
    visible:{
      type: Boolean
    },
    title:{
      type: String,
      default: 'Succesvol gekoppeld'
    },
    description:{
      type: String,
      default: 'Wil je doorgaan naar de gekoppelde klant?'
    },
    customerId:{
      type: [String, Number]
    },
    instanceType:{
      type: String
    },
    instanceId:{
      type: [String, Number]
    }
  },
  methods:{
    navigateToCustomer(){
      this.$emit('cancel');
      if (this.customerId) {
        if (this.instanceType && this.instanceId){
          switch (this.instanceType){
            case 'bank_account':
              this.navigator.navigatePath(this.route('banking.account', [this.customerId, this.customerId, this.instanceId]));
              break;
            case 'policy':
              this.navigator.navigatePath(this.route('vue.insurance.policy', [this.customerId, this.instanceId]));
              break;
            case 'damage':
              this.navigator.navigatePath(this.route('damage.show', [this.customerId, this.instanceId]));
              break;
            case 'mortgage':
              this.navigator.navigatePath(this.route('mortgage.show', [this.customerId, this.instanceId]));
              break;
            case 'obligation':
              this.navigator.navigatePath(this.route('credit.show', [this.customerId, this.instanceId]));
              break;
            default:
              this.navigator.navigatePath(this.route(`customer.dashboard`, [this.customerId]));
              break;
          }
        } else {
          this.navigator.navigatePath(this.route(`customer.dashboard`, [this.customerId]));
        }

      } else {
        console.warn('Geen customerId!')
        this.$notification['warning']({
          message: 'Mislukt',
          description: 'Kan niet naar de klant navigeren.',
        });
      }
    },
  },
};
</script>
